import { getField, updateField } from 'vuex-map-fields'
import api from '@/lib/api'
import {
  PATH_TIME_MANAGEMENT,
  PATH_CONSULTANTS_TIME_MANAGEMENT,
  PATH_MONTHLY_TIME_MANAGEMENT,
  PATH_STAFF_TIME_MANAGEMENT,
  PATH_CONTRACTOR_COMMISSIONS
} from '@/lib/constants/api'
import { COMPLETE, ERROR, IN_PROGRESS } from '@/lib/constants/actionStatuses'
import updateStatus from '@/store/helpers/updateStatus'
import buildInitialState from '@/store/helpers/buildInitialState'
import { hideProgressModal, showProgressModal } from '@/lib/progressModal'
import { notifySuccess, notifyError } from '@/lib/notifications'

const timeManagement = {
  namespaced: true,
  state: buildInitialState({
    timeManagementClientItems: [],
    staffTimeManagementItems: []
  }),
  getters: {
    getField
  },
  mutations: {
    updateStatus,
    updateField,
    setTimeManagementData: (state, timeManagementClientItems) => {
      state.timeManagementClientItems = []
      state.timeManagementClientItems = timeManagementClientItems
    },
    setStaffTimeManagementData: (state, timeManagementItems) => {
      state.staffTimeManagementItems = timeManagementItems
    }
  },
  actions: {
    getTimeManagementData: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time, please wait...' })

      return api.doGet({ path: PATH_CONSULTANTS_TIME_MANAGEMENT, parameters: filters })
        .then(json => json.data)
        .then(timeManagement => {
          commit('updateStatus', { status: COMPLETE })
          commit('setTimeManagementData', timeManagement)
          return timeManagement
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time. Try again later')
          return null
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getStaffTimeManagementData: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting time, please wait...' })

      return api.doGet({ path: PATH_STAFF_TIME_MANAGEMENT, parameters: filters })
        .then(json => json.data)
        .then(timeManagement => {
          commit('updateStatus', { status: COMPLETE })
          commit('setStaffTimeManagementData', timeManagement)
          return timeManagement
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get time. Try again later')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveTimeSheetEntries: ({ commit, dispatch }, payLoad) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving time, please wait...' })
      return api.doPost({ path: PATH_TIME_MANAGEMENT, data: payLoad })
        .then(json => json.data)
        .then(timeSheetEntries => {
          commit('updateStatus', { status: COMPLETE })
          if (!timeSheetEntries) {
            throw new Error('Unable to save time. Try again later')
          }
          notifySuccess(dispatch, 'Time saved')
          return timeSheetEntries
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, error.message || 'Unable to save time. Try again later')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    getMonthlyTimeSheetEntries: ({ commit, dispatch }, filters = {}) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Getting monthly time, please wait...' })

      return api.doGet({ path: PATH_MONTHLY_TIME_MANAGEMENT, parameters: filters })
        .then(json => json.data)
        .then(timeSheetEntries => {
          commit('updateStatus', { status: COMPLETE })
          return timeSheetEntries
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to get monthly time. Try again later')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    },
    saveContractorCommissions: ({ commit, dispatch }, payLoad) => {
      commit('updateStatus', { status: IN_PROGRESS })
      showProgressModal({ dispatch, message: 'Saving contractor commissions, please wait...' })
      return api.doPost({ path: PATH_CONTRACTOR_COMMISSIONS, data: payLoad })
        .then(json => json.data)
        .then(contractorCommissions => {
          commit('updateStatus', { status: COMPLETE })
          if (!contractorCommissions) {
            throw new Error('Unable to save contractor commissions. Try again later')
          }
          notifySuccess(dispatch, 'Contractor commissions saved')
          return contractorCommissions
        })
        .catch((error) => {
          commit('updateStatus', { status: ERROR, error })
          notifyError(dispatch, 'Unable to save contractor commissions. Try again later')
          throw error
        })
        .finally(() => {
          hideProgressModal({ dispatch })
        })
    }
  }
}

export default timeManagement
